export default function guest({ next, router }) {
  if (localStorage.getItem('x-access-token')) {
    return router.push({ name: 'dashboard' });
  }

  return next();
}
